<template>
  <!-- 字典表 -->
  <div>
    <el-table :data="tableData" row-key="id" border  @selection-change="handleSelect" size="mini" :header-cell-style="headerStyle">
      <!--序号-->
      <el-table-column type="selection" align="center" :selectable="selectable"/>
      <el-table-column v-for="(item,index) in tableList" :key="index" :label="item.label" :prop="item.prop"
      :width="item.width || 'auto'" align="center" :sortable="item.sortable" :sort-method="item.prop === 'itemValue' ? handleItemValueSort : null">
        <template #default="scope">
          <span v-if="item.type =='select'">
            <span style="color: green;font-weight: 900;" v-if="scope.row[item.prop] === 1">启用</span>
            <span style="color: red;font-weight: 900;" v-else>禁用</span>
          </span>
          <span v-else>{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
      <!--操作栏-->
      <el-table-column label="操作" width="200" align="center">
        <template #default="scope">
            <el-button id="tableEdit" link type='text' v-if="listBtnShow !== 'DictionaryDataView'" @click="handleList(scope.row)">列表</el-button>
            <el-button id="tableEdit" link type='text' @click="handleEdit(scope.row)">编辑</el-button>
            <el-button id="tableEdit" link type='text' v-if="!scope.row.showItem"  @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <page-button :total="total" :page-size="pageSize" :current-page="currentPage" @pageChange="handlePageChange" @sizeChange="sizeChange"/>
  </div>
</template>

<script>
import { testCaseTableRules } from '@/data/rules'
import PageButton from '@/components/buttons/PageButton.vue'

export default {
  name: 'DictionaryTable',
  components: {
    PageButton
  },
  props: {
    // 父组件表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 页面类型，edit: 编辑 create: 创建
    type: {
      type: String,
      default: 'create'
    },
    // 当前页码
    currentPage: {
      type: Number,
      default: 1
    },
    // 总条数
    total: {
      type: Number,
      default: 0
    },
    // 每页显示条数
    pageSize: {
      type: Number,
      default: 20
    }, // 每页显示条数
    tableList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // 字典表格数据
    dictionaryTableData: {
      get () {
        return this.tableData
      },
      set (val) {
        this.$emit('update:tableData', val)
      }
    }
  },
  data () {
    return {
      // 字典表格规则
      testCaseTableRules: testCaseTableRules,
      listBtnShow: this.$route.name,
    }
  },
  mounted () {},
  methods: {
    headerStyle({ row, column, rowIndex, columnIndex }) {
      // 或者返回对象形式
      return {
        'background-color': '#fafafa',
        'color': '#333',
        'font-weight': 'bold',
        'padding': '0',
      }
    },
    // 选择逻辑函数
    selectable (row, index) {
      // 根据row中的showItem字段决定是否可选
      // 也可以根据其他条件，如index、row的其他属性等
      return !row.showItem
    },
    // 选择表格行
    handleSelect (selection) {
      this.$emit('select', selection)
    },
    // 表格校验
    handleValidation () {
      return Promise.all(this.$refs.dynamicCell.map(cell => cell.handleValidation()))
    },
    // 页码改变时触发
    handlePageChange (val) {
      this.$emit('pagechange', val)
    },
    // 页码大小改变
    sizeChange (val) {
      this.$emit('sizeChange', val)
    },
    handleEdit (row) {
      this.$emit('handleEdit', row)
    },
    handleDelete (row) {
      console.log(row);
      this.$emit('handleDelete', row)
    },
    handleList (row) {
      this.$emit('handleList', row)
    },
    // 字典项值自定义排序函数
    handleItemValueSort (a, b) {
      // 尝试将值转换为数字进行排序
      const valueA = parseFloat(a.itemValue)
      const valueB = parseFloat(b.itemValue)
      
      // 如果两个值都是有效数字，按数字大小排序
      if (!isNaN(valueA) && !isNaN(valueB)) {
        return valueA - valueB
      }
      
      // 如果有一个不是有效数字，按字符串排序
      return String(a.itemValue).localeCompare(String(b.itemValue))
    }
  }
}
</script>

<style>

</style>
